export default __webpack_public_path__ + "static/media/analytics-graph-no-data-image.060becda.svg";